module.exports = __webpack_public_path__ + "static/media/museun-plan.cbd1764c.svg";